export enum MapStyleNames {
    Light = "light",
    Satellite = "satellite",
    White = "white",
    Dark = "dark",
}
